<template>
  <div class="wrp-master">
    <div class="back">
      <span @click="goback"><i class="el-icon-back"></i>Back</span>
    </div>
    <div class="bgd">
      <div class="con">
        <h1>Edit Master Account</h1>
        <h2><i style="font-style:normal;color:#fff">*</i> Owner's Name</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['name']}" @blur="validateInput('name')" type="text" v-model="name" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Mobile</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['number']}" @blur="validateInput('number')" type="text" v-model="number" @input="validate('number')" :maxlength="number.slice(0, 1) === '4' ? 9 : 10" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Link Venue</h2>
        <div class="autocompleteItem">
          <el-autocomplete
            v-model="venuename"
            :fetch-suggestions="querySearchAsync"
            placeholder=" "
            :class="{'border-error': validationInputError['venuename']}" 
            @blur="validateInput('venuename')"
            @select="handleSelect"
            ></el-autocomplete>
        </div>
        <div class="selectedVenue clear">
            <div class="venue" v-for="(item, index) in selectedVenue" :key="item.address">{{item.value}}
                <div class="ico" @click="removeVenue(index)"></div>
            </div>
        </div>
        <div class="btm-btns clear">
          <button class="cancel" @click="goback">Cancel</button>
          <button class="confirm" :class="{'disabled': !isComplete}" :disabled="!isComplete" @click="confirm">Confirm</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '../../api/account'

export default {
  data () {
    return {
      name: '',
      number: '',
      venuename: '',

      timeout:  null,
      allVenue: [],
      selectedVenue: [],
      selectedVenueId: [],
      // 是否输入完整
      isComplete: false,
      validationInputError: {
        name: false,
        number: false,
        username: false,
        password: false,
        venuename: false
      }
    }
  },
  mounted () {
      var that = this
      if (!that.$route.params.id)
        return
      that.allVenue = this.loadAll()
      api.masterVenue({
          params: that.$route.params.id,
          callback: (res) => {
              let data = res.data.data
              if (res.data.code === 0) {
                if (data.subVenueList) {
                    data.subVenueList.forEach((item => {
                        that.selectedVenue.push({
                          address: item.venueId,
                          value: item.venueName
                        })
                        that.selectedVenueId.push(item.venueId)
                    }))
                }
                that.name = data.venueOwner
                that.number = data.venueMobile
                console.log('that.name')
                console.log(that.name)
                console.log('that.number')
                console.log(that.number)
                that.validateComplete()
              } else {
                  Utils.alert('', res.data.message, 'error')
              }
          }
      })
  },
  methods: {
    validateInput(modelName) {
      const model = typeof(this[modelName]) === 'number' ? JSON.stringify(this[modelName]) : this[modelName];
      if (model.replace(/\s+/g,'') === '') {
        this.validationInputError[modelName] = true;
      } else {
        this.validationInputError[modelName] = false;
      }

      if (modelName = 'venuename' && this.selectedVenue.length > 0) {
        this.validationInputError['venuename'] = false
      } else {
        this.validationInputError['venuename'] = true
      }

    },
    removeVenue (index) {
        var that = this
        that.selectedVenueId.splice(index, 1)
        that.selectedVenue.splice(index, 1)
        that.validateComplete()
    },
    loadAll() {
        let result = []
        api.subVenueList({
            callback: (res) => {
                if (res.data.code === 0) {
                    res.data.data.forEach((item) => {
                        result.push({
                            value: item.venueName,
                            address: item.venueId
                        })
                    })
                } else {
                    Utils.alert('', res.data.message, 'error')
                }
            }
        })
        return result
    },
    querySearchAsync(queryString, cb) {
        var allVenue = this.allVenue;
        var results = queryString ? allVenue.filter(this.createStateFilter(queryString)) : allVenue;
        cb(results);
    },
    createStateFilter(queryString) {
        return (state) => {
          return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    },
    handleSelect(item) {
        var that = this
        that.venuename = ''
        if (that.selectedVenueId.indexOf(item.address) !== -1) {
            Utils.alert('', 'This venue is already selected', 'error')
            return
        }
        that.selectedVenueId.push(item.address)
        that.selectedVenue.push(item)
        that.validateComplete()
    },
    goback () {
      this.$router.go(-1)
    },
    validate (type) {
      var that = this
      if (type === 'number') {
        this.number = this.number.replace(/[^\d]/g,'')
        that.validateComplete()
      } 
    },
    validateComplete(e, type) {
      var that = this
      if (that.name.replace(/\s+/g,'') !== '' &&
      that.number.replace(/\s+/g,'') !== '' &&
      that.selectedVenue.length > 0) {
        that.isComplete = true
      } else {
        that.isComplete = false
      }

    },
    confirm() {
      var that = this
      if (!that.$route.params.id)
        return
      let request_params = {
        venueMobile: that.number,
        venueOwner: that.name,
        subVenueIdList: that.selectedVenueId,
        venueId: that.$route.params.id
      }
      this.$box.loadings()
      api.updateMasAnt({
        params: request_params,
        callback: this.addCallback
      })
    },
    addCallback(res) {
      var that = this
      that.$box.loadings(2)
      if(res.data.code == 0){
        that.$router.go(-1)
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.selectedVenue{
    .venue{
        padding: 6px 20px;
        box-sizing: border-box;
        background: #151C27;
        border: 1px solid #5F5F5F;
        float: left;
        margin-right: 30px;
        margin-top: 30px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 38px;
        position: relative;
        .ico{
            width: 20px;
            height: 20px;
            position: absolute;
            right: -10px;
            top: -10px;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center center;
            background-image: url('../../assets/8.png');
        }
    }
}
.wrp-master{
  color: #fff;
  padding-bottom: 50px;
  .back{
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 56px;
    font-family: 'SFProText-Semibold';
    background: #212429;
    width: 100%;
    z-index: 4;
    height: 20px;
    span{
      display: inline-block;
      width: 100px;
      cursor: pointer;
      i{
        margin-right: 10px;
      }
    }
  }
  .bgd{
    width: 100%;
    background: #2B3444;
    padding: 50px 0 65px 0;
    margin-bottom: 50px;
    .con{
      width: 740px;
      margin: 0 auto;
      .btm-btns{
        width: 610px;
        margin: 65px auto 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: #2B3444;
          float: left;
          box-sizing: border-box;        
          font-size: 26px;
          cursor: pointer;
        }
        .cancel{
          margin-right: 50px;
          border: 2px solid #FFFFFF;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #fff;
        }
        .confirm{
          border: 2px solid #EA3796;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #EA3796;
        }
        .disabled{
          border: 2px solid #8E3771;
          color: #8E3771;
          cursor: not-allowed;
        }
      }
      h1{
        font-family: 'PingFangSC-Semibold';
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .inputItem{
        width: 100%;
        margin-bottom: 30px;
        position: relative;
        input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
          height: 50px;
        }
        .lft{
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: #fff;
        }
        .rgt{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: #fff;
        }
      }
      .btns{
        width: 100%;
        box-sizing: border-box;
        padding-left: 16px;
        div{
          float: left;
          line-height: 60px;
          cursor: pointer;
        }
        .add{
          margin-right: 32px;
        }
        .reset{
          color: #EA3796;
        }
      }
    }
  }

  .border-error {
    border-color: #f20014 !important;
    .el-input {
        border: 1px solid #f20014 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/editMaster.vue